var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha-container"},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height}}),_c('button',{attrs:{"type":"button"},on:{"click":_vm.regenerate}},[_vm._v("↻")])])}
var staticRenderFns = []

export { render, staticRenderFns }